import axiosInstance from 'api/axiosInstance'
import { useAccessToken } from 'store'

const postKeepAliveOptions = (
    dataToStringify?: any,
    overrideObj?: RequestInit | undefined
) => ({
    method: 'POST',
    headers: new Headers({
        Authorization: `Bearer ${useAccessToken()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }),
    keepalive: true,
    ...(dataToStringify && { body: JSON.stringify(dataToStringify) }),
    ...overrideObj
})

export const trackingFetch = async (
    path: string,
    dataToStringify?: any,
    additionalOptions?: RequestInit | undefined
) => {
    return await fetch(
        `${process.env.REACT_APP_API_URL}${path}`,
        postKeepAliveOptions(dataToStringify, additionalOptions)
    )
}

export const apiViewPost = async (id: string, shouldFire: boolean = true) => {
    if (!shouldFire) return undefined
    const { body } = await trackingFetch(`/api/post/views`)
    return body
}

export const postsImpression = async (ids: string[]) => {
    const { body } = await trackingFetch('/api/post/impression', {
        post_ids: ids
    })
    return body
}

export type VideoPlayedPayload = {
    video_id: string
    total_watch_seconds: number
    unique_watch_seconds: number
    completion_rate: number
    video_duration_seconds: number
    is_preview: boolean
}

export type VideoPlayedApiPayload = {
    total_watch_seconds: number
    unique_watch_seconds: number
    completion_rate: number
    video_duration_seconds: number
    is_preview: boolean
}

export const apiVideoPlayedTime = async (
    video_id: string,
    video_plays: VideoPlayedApiPayload[]
) => {
    const { body } = await trackingFetch(
        `/api/video/${video_id}/play`,
        { video_plays }
    )

    return body
}

export const apiFanProfileSession = async (
    profileId: number,
    sessionDuration: number
) => {
    const { body } = await trackingFetch('/api/profile/fan-session', {
        profile_id: profileId,
        session_duration: sessionDuration
    })
    return body
}

export const creatorsImpression = async (model_ids: string[], tab?: string) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/suggestion-impression',
        data: {
            model_ids,
            tab
        }
    })

    return data
}
